import {
	combineReducers
} from 'redux';
import {
	routerReducer
} from 'react-router-redux';
import { connectRouter } from 'connected-react-router'

import signin from './signinReducer';
import specialist from './specialistReducer';
import users from './usersReducer';
import appointment from './appointmentReducer';
import uploadDocument from './uploadDocumentReducer';
import SpecialistBlog from './specialistBlogReducer';
import statistics from './statisticsReducer';
import dashboard from './dashboardReducer';
import vettingUser from './vettingUser';
import adminUser from './admin/user/userReducer';
import marketing from './marketingReducer';
import gapi from './gapiReducer';
import dispute from './disputeReducer';


import {
	reducer as toastrReducer
} from 'react-redux-toastr'


const rootReducer = (history) => combineReducers({
	router: connectRouter(history),
	signin,
	users,
	appointment,
	specialist,
	uploadDocument,
	SpecialistBlog,
	dashboard,
	statistics,
	adminUser,
	// routing: routerReducer,
	toastr: toastrReducer,

	vettingUser,
	dispute,
	marketing,
	gapi,
    // heelo: []
});

export default rootReducer;
